import React, { useState } from 'react';

const CandidateSearchProcessNotes = (props) => {
    const [processNote, setProcessNote] = useState({});
    const {initProcessNote, onChange, onSave} = props

    React.useEffect(() => {
        setProcessNote(initProcessNote || {});
    }, [initProcessNote]);

    const onChangeProcessInput = (event) => {
        console.log('onChangeProcessInput');
        processNote[event.target.name] = event.target.value
        setProcessNote({...processNote})
        if (onChange) {
            onChange(processNote);
        };
    };

    return (
        <div className='container-fluid'>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Process Notes</h3>
                </div>
                <div className='card-body table-responsive p-0 w-100'>
                <div className='input-group col-sm-12 m-3'>
                    <label className={'w-100'}>Note Discussion</label>
                    <textarea className='form-control'
                            value={processNote.discussion_note || ''}
                            name={'discussion_note'}
                            onChange={onChangeProcessInput} />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default CandidateSearchProcessNotes;